/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.9.0 (NJsonSchema v10.4.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming



export interface ApplicationInfo {
    applicationManifestId?: string;
    applicationName?: string;
    description?: string;
    permissions?: AppPermissionInfo[];
    canDelete?: boolean;
}

export interface AppPermissionInfo {
    nameKey?: string;
    description?: string;
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors?: { [key: string]: string[]; };
}

export interface ValidationProblemDetails extends HttpValidationProblemDetails {
    errors?: { [key: string]: string[]; };
}

export interface ApplicationValidationProblemDetails extends ValidationProblemDetails {
    messages?: ApplicationMessage[];
}

export interface ApplicationMessage {
    severity?: ApplicationMessageSeverityType;
    message?: string;
    relatedField?: string | null;
}

export enum ApplicationMessageSeverityType {
    Success = "Success",
    Information = "Information",
    Warning = "Warning",
    Error = "Error",
}

export interface ApplicationProblemDetails extends ProblemDetails {
    messages?: ApplicationMessage[];
}

export interface FeatureFlagModel {
    isAutoEnrolledEmailDomainsFeatureEnabled?: boolean;
    canListProfiles?: boolean;
    canListApplications?: boolean;
    canListOrganizations?: boolean;
    canListUsers?: boolean;
    canCreateUsers?: boolean;
    canAddOrganizations?: boolean;
    canQueryUsers?: boolean;
}

export interface OrganizationSummaryInfo {
    organizationId?: string;
    isEnabled?: boolean;
    name?: string;
    profileCount?: number;
    profileIds?: string[];
    canViewDetails?: boolean;
}

export interface OrganizationDetailInfo {
    organizationId?: string;
    isEnabled?: boolean;
    name?: string;
    organizationType?: OrganizationType | null;
    profiles?: OrganizationProfileSummaryInfo[];
    profileDefaultRoles?: OrganizationProfileDefaultRoleSummaryInfo[];
    autoEnrollEmailSuffixes?: string[];
    organizationRoles?: OrganizationRoleSummaryInfo[];
    organizationUsers?: OrganizationUserSummaryInfo[];
    versionNumber?: number;
    securityFlags?: OrganizationSecurityFlags;
}

export enum OrganizationType {
    Undefined = 0,
    Internal = 1,
    External = 2,
}

export interface OrganizationProfileSummaryInfo {
    profileId?: string;
    name?: string | null;
    description?: string | null;
    usageType?: ProfileUsageType | null;
    canMaintainOrganizationProfileAssociation?: boolean;
}

export enum ProfileUsageType {
    Internal = 1,
    ExternalIndividual = 2,
    ExternalOrganization = 3,
}

export interface OrganizationProfileDefaultRoleSummaryInfo {
    profileDefaultRoleId?: string;
    profileId?: string;
    name?: string | null;
    description?: string | null;
    isPrivilegedRole?: boolean | null;
    canMaintainProfileRoleAssociation?: boolean;
}

export interface OrganizationRoleSummaryInfo {
    organizationRoleId?: string;
    organizationId?: string;
    name?: string;
    description?: string;
}

export interface OrganizationUserSummaryInfo {
    userId?: string;
    organizationId?: string;
    isEnabled?: boolean;
    emailAddress?: string | null;
    displayName?: string | null;
    givenName?: string | null;
    surname?: string | null;
    externalIdentity?: ExternalUserInfo | null;
    profileDefaultRoleIds?: string[];
}

export interface ExternalUserInfo {
    issuer?: string;
    id?: string;
    identityProvider?: string;
    identityProviderDisplayName?: string;
}

export interface OrganizationSecurityFlags {
    canEdit?: boolean;
    canListUsers?: boolean;
    canAddUsers?: boolean;
    canDelete?: boolean;
}

export interface OrganizationCreateInfo {
    organizationId?: string;
    isEnabled: boolean;
    name: string;
    organizationType?: OrganizationType;
    profiles?: string[];
    autoEnrollEmailSuffixes?: string[];
}

export interface OrganizationUpdateInfo {
    organizationId: string;
    isEnabled: boolean;
    name: string;
    organizationType?: OrganizationType;
    profiles?: string[];
    autoEnrollEmailSuffixes?: string[];
    versionNumber?: number;
}

export interface OrganizationUserDetailsInfo {
    isEnabled?: boolean;
    userInfo?: UserInfo | null;
    profileDefaultRoles?: ProfileDefaultRoleInfo[];
    isNewUser?: boolean;
    versionNumber?: number;
    securityFlags?: OrganizationUserSecurityFlags;
}

export interface UserInfo {
    userId?: string;
    email?: string | null;
    displayName?: string | null;
    givenName?: string | null;
    surname?: string | null;
    externalIds?: ExternalUserInfo[];
    securityFlags?: UserSecurityFlags | null;
}

export interface UserSecurityFlags {
    canView?: boolean;
    canUpdate?: boolean;
    canDelete?: boolean;
    canCalculateClaims?: boolean;
}

export interface ProfileDefaultRoleInfo {
    profileDefaultRoleId?: string;
    profileId?: string;
    name?: string | null;
    description?: string | null;
    isPrivilegedRole?: boolean | null;
    applicationPermissions?: ApplicationPermissionSummaryInfo[];
}

export interface ApplicationPermissionSummaryInfo {
    applicationManifestId?: string;
    applicationName?: string | null;
    permissions?: PermissionSummaryInfo[];
}

export interface PermissionSummaryInfo {
    nameKey?: string;
    description?: string;
    valid?: boolean;
}

export interface OrganizationUserSecurityFlags {
    canViewUser?: boolean;
    canEditUser?: boolean;
    canRemoveUser?: boolean;
}

export interface OrganizationUserEditInfo {
    isEnabled: boolean;
    profileRoles: ProfileRoleReferenceInfo[];
    organizationRoleIds: string[];
    versionNumber?: number;
}

export interface ProfileRoleReferenceInfo {
    profileId: string;
    profileDefaultRoleId: string;
}

export interface ProfileSummaryInfo {
    profileId?: string;
    name?: string;
    description?: string;
    sourceApplicationManifestName?: string | null;
    usageType?: ProfileUsageType | null;
    securityFlags?: ProfileSecurityFlags | null;
}

export interface ProfileSecurityFlags {
    canView?: boolean;
    canViewDefaultRoles?: boolean;
    canViewApplicationPermissions?: boolean;
}

export interface ProfileDetailsInfo {
    profileId?: string;
    name?: string;
    description?: string;
    usageType?: ProfileUsageType | null;
    securityFlags?: ProfileSecurityFlags | null;
    roles?: ProfileDefaultRoleInfo[];
    applicationPermissions?: ApplicationPermissionSummaryInfo[];
}

export interface UserOrganizationSummaryInfo {
    organizationId?: string;
    isUserEnabled?: boolean;
    name?: string;
}

export interface ExternalUserEditInfo {
    issuer?: string;
    id?: string;
}

export interface UserClaimsInfo {
    auth_user_id?: string;
    permissions?: string[] | null;
}

export interface CalculateClaimsRequest {
    userId: string;
    applicationId: string;
}

export interface UserQuery {
    userId?: string | null;
    email?: string | null;
    displayName?: string | null;
    givenName?: string | null;
    surname?: string | null;
    b2cId?: string | null;
}